export const STORAGE_KEY = 'locale';
